import React from 'react';
import './Select.css';

/**
 * Select component with shadcn-like styling
 */
const Select = React.forwardRef(({
    className = '',
    error,
    children,
    ...props
}, ref) => {
    const classNames = [
        'select',
        error ? 'select-error' : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <select
            ref={ref}
            className={classNames}
            {...props}
        >
            {children}
        </select>
    );
});

Select.displayName = 'Select';

/**
 * Textarea component
 */
const Textarea = React.forwardRef(({
    className = '',
    error,
    ...props
}, ref) => {
    const classNames = [
        'textarea',
        error ? 'textarea-error' : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <textarea
            ref={ref}
            className={classNames}
            {...props}
        />
    );
});

Textarea.displayName = 'Textarea';

export { Select, Textarea };
